/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M5.25 1.5C4.0074 1.5 3 2.5074 3 3.75v3C3 7.9926 4.0074 9 5.25 9h3c1.2426 0 2.25-1.0074 2.25-2.25v-3c0-1.2426-1.0074-2.25-2.25-2.25h-3Zm3-1.5C10.3211 0 12 1.679 12 3.75v3c0 2.071-1.6789 3.75-3.75 3.75h-3c-2.071 0-3.75-1.679-3.75-3.75v-3C1.5 1.679 3.179 0 5.25 0h3Zm-4.5 13.5c-1.2426 0-2.25 1.0074-2.25 2.25v4.5c0 1.2426 1.0074 2.25 2.25 2.25h4.5c1.2426 0 2.25-1.0074 2.25-2.25v-4.5c0-1.2426-1.0074-2.25-2.25-2.25h-4.5Zm4.5-1.5c2.0711 0 3.75 1.6789 3.75 3.75v4.5C12 22.3211 10.3211 24 8.25 24h-4.5C1.679 24 0 22.3211 0 20.25v-4.5C0 13.6789 1.679 12 3.75 12h4.5ZM22.5 3.75c0-1.2426-1.0074-2.25-2.25-2.25h-3C16.0074 1.5 15 2.5074 15 3.75v3C15 7.9926 16.0074 9 17.25 9h3c1.2426 0 2.25-1.0074 2.25-2.25v-3Zm-9 0C13.5 1.679 15.1789 0 17.25 0h3C22.3211 0 24 1.679 24 3.75v3c0 2.071-1.6789 3.75-3.75 3.75h-3c-2.0711 0-3.75-1.679-3.75-3.75v-3Zm3.75 9.75c-1.2426 0-2.25 1.0074-2.25 2.25v3c0 1.2426 1.0074 2.25 2.25 2.25h3c1.2426 0 2.25-1.0074 2.25-2.25v-3c0-1.2426-1.0074-2.25-2.25-2.25h-3Zm3-1.5c2.0711 0 3.75 1.6789 3.75 3.75v3c0 2.0711-1.6789 3.75-3.75 3.75h-3c-2.0711 0-3.75-1.6789-3.75-3.75v-3c0-2.0711 1.6789-3.75 3.75-3.75h3Z"
    clipRule="evenodd"
  />,
  'Samples'
);
